import { z } from 'zod';
import { PrivateEntityId } from './encrypted-entities.js';
import { ProjectSnapshot } from './wire.js';
/** Inside a signed encrypted run.start only. Relays must never supply this snapshot. */
export const PrivateProjectBinding = z.strictObject({
    /**
     * Identity in the daemon's already configured local viko.project.yaml (v1 registrations).
     * account-projects: a daemon with a checkout entry for `snapshot.id` resolves the path from
     * its own table and ignores any relayed `repoPath`.
     */
    localProjectId: z.string().min(1).max(256),
    snapshot: ProjectSnapshot.pick({
        id: true,
        name: true,
        repoPath: true,
        workstreams: true,
        tasks: true,
        rules: true,
        history: true,
    })
        .extend({ id: PrivateEntityId })
        .strict(),
});
//# sourceMappingURL=private-project.js.map